import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/app";
import "bootstrap/dist/css/bootstrap.css?v=2";

const localisationStrings = {
  whatDoYouWant: {
    pl: "Ankietę na jaki temat chcesz stworzyć?",
    en: "What do you want to survey?",
  },
  surveyGoal: {
    pl: 'wpisz cel badania np. "chcę się dowiedzieć jak ludzie korzystają z serwisów randkowych"',
    en: 'type survey goal i.e. "find out how people use dating services"',
  },
  showSurvey: {
    pl: "Przygotuj ankietę w następującym języku",
    en: "Show survey in the following language",
  },
  generate: {
    pl: "Wygeneruj",
    en: "Generate",
  },
  more: {
    pl: "więcej",
    en: "more",
  },
  surveyQuestion: {
    pl: "pytania do ankiety",
    en: "survey questions",
  },
  createForFree: {
    pl: "Stwórz tę ankietę bezpłatnie",
    en: "Create this survey for free",
  },
  register: {
    pl: "https://app.webankieta.pl/rejestracja?utm_source=landing&utm_medium=cpc&utm_campaign=ai",
    en: "https://app.startquestion.com/registration?utm_source=landing&utm_medium=cpc&utm_campaign=ai",
  },
  label: {
    pl: [
      "Proszę czekać! Pracujemy nad wczytaniem strony, aby zapewnić Ci najlepsze doświadczenie.",
      "Czekanie na naszą niesamowitą stronę jest jak czekanie na filiżankę kawy. Obiecujemy, że warto!",
      "Zrób głęboki oddech. Wkrótce przeniesiemy Cię do magicznego świata naszej witryny.",
      "Czy wiesz, że przeciętna osoba spędza około 6 miesięcy swojego życia na czekaniu na różne rzeczy? Staramy się to ograniczyć tutaj!",
      "Podczas ładowania strony pomyśl o tym, czego chciałbyś znaleźć na naszej stronie i zamień to w rzeczywistość!",
      "Szybka prośba: Podziel się naszą stroną w mediach społecznościowych, aby rozprzestrzenić nudę oczekiwania!",
      "W międzyczasie możesz sprawdzić naszą sekcję na stronie głównej, aby dowiedzieć się więcej o naszych usługach.",
      "Rozumiemy, że oczekiwanie może być trudne, ale miej pewność, że ta strona jest warta każdej sekundy oczekiwania!",
      "Dziękujemy za cierpliwość! Dodajemy ostatnie szlify do strony, aby była idealna dla Ciebie.",
      "Czy wiesz, że oczekiwanie może zwiększyć twoje oczekiwanie? Przygotuj się na zdumienie!",
      "Trzymaj się! Prawie skończyliśmy tworzyć dla Ciebie płynne doświadczenie przeglądania.",
      "Podczas krótkiego oczekiwania, dlaczego by nie przekąsić czegoś? Gdy wrócisz, strona będzie gotowa na Ciebie.",
      "Rozluźnij się i napij się herbaty. Strona zostanie wczytana, zanim się obejrzysz!",
      "Dziękujemy za wyrozumiałość! Nasz zespół pracuje intensywnie nad zoptymalizowaniem strony, aby jej wczytywanie było szybsze.",
      "Podczas ładowania strony, poświęć chwilę na docenienie drobnych rzeczy wokół ciebie. Czasem to właśnie małe momenty mają największe znaczenie.",
      "Usiądź wygodnie, zrelaksuj się i ciesz się wirtualną podróżą, którą zaraz rozpoczniemy. Przygoda czeka!",
      "Doceniamy Twoją cierpliwość. W międzyczasie sprawdziłeś już nasze specjalne oferty i promocje?",
      "Dziękujemy za oczekiwanie! Tworzymy wyjątkowe doświadczenie specjalnie dla Ciebie.",
      "Podczas ładowania strony, dlaczego nie zajrzysz na naszego bloga po ciekawe artykuły?",
      "Czy wiesz, że dobre rzeczy przychodzą do tych, którzy czekają? Przygotuj się na coś wspaniałego!",
      "Trzymaj się mocno i przygotuj się na olśniewające przeżycie. Nasza strona wczytuje się w całej swojej chwale!",
      "Zatrzymaj się na chwilę i ciesz się pięknem oczekiwania. Nasza strona jest warta tego czekania!",
      "Dziękujemy za cierpliwość! Pracujemy intensywnie za kulisami, aby uczynić Twoją wizytę nadzwyczajną.",
      "Usiądź wygodnie i przygotuj się na niezapomnianą podróż przez naszą stronę. Będzie warto, obiecujemy!",
      "Dziękujemy za wyrozumiałość. Optymalizujemy stronę, aby zapewnić płynne i szybkie doświadczenie.",
    ],
    en: [
      "Hang tight! We're working on loading the page to provide you with the best experience.",
      "Waiting for our amazing page is like waiting for a cup of coffee. We promise it's worth it!",
      "Take a deep breath. We'll transport you to the magical world of our website in just a moment.",
      "Did you know that an average person spends approximately 6 months of their life waiting for various things? We've tried to minimize that time here!",
      "While the page is loading, think about what you'd like to find on our site and turn it into reality!",
      "Quick request: Share our page on social media to spread the boredom of waiting!",
      "In the meantime, you can check out our homepage section to learn more about our services.",
      "We understand that waiting can be hard, but rest assured, this page is worth every second of anticipation!",
      "Thanks for your patience! We're putting the final touches on the page to make it perfect for you.",
      "Did you know that waiting can actually increase your anticipation? Get ready to be amazed!",
      "Hang in there! We're almost done creating a seamless browsing experience just for you.",
      "During this short wait, why not grab a snack? We'll have the page ready for you when you return.",
      "Feel free to stretch your legs or grab a cup of tea. We'll have the page loaded before you know it!",
      "Thanks for your understanding! Our team is working diligently to optimize the page for a faster loading time.",
      "While the page loads, take a moment to appreciate the small things around you. Sometimes, it's the little moments that matter the most.",
      "Sit back, relax, and enjoy the virtual journey we're about to take you on. Adventure awaits!",
      "We appreciate your patience. In the meantime, have you checked out our special offers and promotions?",
      "Thanks for waiting! We're crafting an exceptional experience just for you.",
      "While the page loads, why not explore our blog for some interesting reads?",
      "Did you know that good things come to those who wait? Get ready for something great!",
      "Hang tight and get ready to be dazzled. Our page is loading with all its glory!",
      "Take a moment to appreciate the beauty of anticipation. Our page is worth the wait!",
      "Thanks for your patience! We're working diligently behind the scenes to make your visit extraordinary.",
      "Sit tight and prepare to embark on an unforgettable journey through our website. It'll be worth it, we promise!",
      "Thanks for your understanding. We're optimizing the page to ensure a seamless and speedy experience.",
    ],
  },
};

const lang = window.location.hostname === "www.webankieta.pl" ? "pl" : "en";

const rootElement = document.getElementById("widget-container");
ReactDOM.createRoot(rootElement).render(
  <App s={localisationStrings} lang={lang} />
);
